<template>
  <div>
    <main-header :siteTitle="siteTitle" :siteURL="siteURL">
      <ul slot="navlist">
        <li v-for="(item, index) in siteNav.slice(0,3)" :key="index">
          <router-link :to="item.route"
          :class="{'active': activeState[index]}">
            {{ item.label }}
          </router-link>
        </li>
        <li :key="3">
          <el-dropdown class="nav-dropdown" :hide-timeout="300">
            <a :class="{'active': activeState[3]}">
              {{ siteNav[3].label }}
              <i class="el-icon-arrow-down"></i>
            </a>
            <el-dropdown-menu slot="dropdown" class="nav-dropdown-menu">
              <li v-for="(item, index) in toolsNav" :key="index" 
              class="nav-dropdown-item">
                <router-link :to="item.route" 
                :class="{'active': toolsActiveState[index]}">
                  {{ item.label }}
                </router-link>
              </li>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li :key="4">
          <router-link :to="siteNav[4].route"
          :class="{'active': activeState[4]}">
            {{ siteNav[4].label }}
          </router-link>
        </li>
      </ul>
    </main-header>
  </div>
</template>

<script>
import MainHeader from '@/components/header/MainHeader.vue'
export default {
  components: { MainHeader },
  data() {
    return {
      activeState: [0,0,0,0,0],
      siteTitle: 'scPlantDB',
      siteURL: 'https://biobigdata.nju.edu.cn/scplantdb',
      siteNav: [
        {route: '/home', label: 'Home'},
        {route: '/dataset', label: 'Browser'},
        {route: '/marker', label: 'Marker'},
        {route: '/tools', label: 'Tools'},
        {route: '/help', label: 'Help'},
      ],
      toolsActiveState: [0,0,0],
      toolsNav: [
        {route: '/tools/blast', label: 'Blast'},
        {route: '/tools/compct', label: 'Cell type Comparator'},
        {route: '/tools/predct', label: 'Cell type Predictor'}
      ]
    }
  },
  watch: {
    $route: function() {
      // console.log(this.$route)
      if(this.$route.name==='home'){
        this.activeState = [0,0,0,0,0]
        this.toolsActiveState = [0,0,0]
        this.activeState[0] = 1
      }else if(this.$route.name==='dataset'){
        this.activeState = [0,0,0,0,0]
        this.toolsActiveState = [0,0,0]
        this.activeState[1] = 1
      }else if(this.$route.name==='marker'){
        this.activeState = [0,0,0,0,0]
        this.toolsActiveState = [0,0,0]
        this.activeState[2] = 1
      }else if(this.$route.name === 'blast'){
        this.activeState = [0,0,0,0,0]
        this.activeState[3] = 1
        this.toolsActiveState = [0,0,0]
        this.toolsActiveState[0] = 1
      }else if(this.$route.name === 'compct'){
        this.activeState = [0,0,0,0,0]
        this.activeState[3] = 1
        this.toolsActiveState = [0,0,0]
        this.toolsActiveState[1] = 1
      }else if(this.$route.name === 'predct'){
        this.activeState = [0,0,0,0,0]
        this.activeState[3] = 1
        this.toolsActiveState = [0,0,0]
        this.toolsActiveState[2] = 1
      }else if(this.$route.name==='help'){
        this.activeState = [0,0,0,0,0]
        this.toolsActiveState = [0,0,0]
        this.activeState[4] = 1
      }else{
        this.activeState = [0,0,0,0,0]
        this.toolsActiveState = [0,0,0]
      }
    }
  },
}
</script>

<style lang="scss">
.nav-dropdown {
  font-size: 16px !important;
  color: #505050 !important;
}
.nav-dropdown-menu {
  transform: translateY(8%) !important;
  padding: 0;
}
.nav-dropdown-item {
  list-style-type: none;
  a{
    height: 36px;
    line-height: 36px;
    font-weight: 600;
    text-decoration: none;
    text-align: center; 
    display: block;
    color: #505050;
    padding: 0 8px;

    &:hover {
      color: #505050;
      background-color: #2ca25f33;
    }
    &.active {
      color: #2ca25f;
    }
  }
}
</style>